import {checkTlistReplacement} from 'src/firebase/fishes';
import axios from 'axios';

export const checkTlist = (data) => {
  return new Promise((resolve, reject) => {
    checkTlistReplacement(data)
      .then(data=>{

      
        resolve(data);
      })
      .catch(function (error) {
      // handle error
        reject(error);
      });
  });
};

export const sendFishes = (sender, platform, sendFishes) => {
  return new Promise((resolve, reject) => {
 
    // https://script.google.com/macros/s/AKfycbzUSmXPFXia_fb3QfoWycM2nIOKTRRNEUFWmJ4LK9Uj/dev?sender=Jeffrey&platform=Facebook&sendFishes=test1,test2
    const tlistEndPoint =
      'https://script.google.com/macros/s/AKfycbwRD9VrOMlBysC14fEECN8QlVPNk6i8o7r2chDpbszSM5loksmKiO5KCQ/exec';

    const params = {
      sender: sender,
      platform: platform,
      sendFishes: sendFishes
        .filter((x) => x.name !== '')
        .map((x) => x.name)
        .join(),
    };

    const query = Object.keys(params)
      .map((x) => {
        return x + '=' + params[x];
      })
      .join('&');

    axios
      .get(tlistEndPoint + '?' + query)
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        // handle error
        reject(error);
      });
  });
};

const APIKeyPool = [];

export const telegramMessage = (telegramId, message)=>{



  const token = process.env.REACT_APP_TELEGRAM_ID;

  const url =`https://api.telegram.org/bot${token}/sendMessage?chat_id=${telegramId}&text=${message}&parse_mode=Markdown`;

  return new Promise((resolve,reject)=>{
    axios({
      method: 'POST',
      url: url
    })
      .then(response=>resolve(response))
      .catch(reject);
  });
};
export const nameToGender = (output) => {
  let apiKeyNumber = 0;
  const nameToGenderEndpoint = (personalNames) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: 'https://v2.namsor.com/NamSorAPIv2/api2/json/genderFullBatch',
        data: { personalNames: personalNames },
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Api-Key': APIKeyPool[apiKeyNumber],
        },
      })
        .then((x) => resolve(x))
        .catch((x) => {
          apiKeyNumber += 1;

          if (APIKeyPool.length > apiKeyNumber) {
            nameToGenderEndpoint(personalNames)
              .then((x) => resolve(x))
              .catch((x) => reject(x));
          } else {
            reject(x);
          }
        });
    });
  };

  return new Promise((resolve, reject) => {
    let personalNames = [];

    output.map((x, idx) => {
      personalNames = [
        ...personalNames,
        {
          id: idx,
          name: x.platform !== 'Instagram' ? x.name : x.others,
        },
      ];
    });
    nameToGenderEndpoint(personalNames)
      .then((response) => response.data)
      .then((data) => {
        let tempOutput = output;

        data.personalNames.map((x) => {
          tempOutput[x.id].gender = x.likelyGender;
          tempOutput[x.id].genderScore = x.probabilityCalibrated;
        });
        resolve(tempOutput);
      })
      .catch((tempOutput) => {
        reject({
          status: 'fail',
          message: 'Gender pridiction is not working today',
          err: tempOutput,
        });
      });
  });
};

export const getFacebookGroupByFacebookId = (id,detail=false)=>{

  const endPoint = 'https://graph.facebook.com/v10.0';
  const options = !detail?'fields=id,name,link':'fields=id,name,picture,description,link';
  const accessToken = 'access_token=EAAGz2z7Sw6kBABaj0FhPm9sfxwz7o4vVKpWEPRZCQdvZAvDWM0m3lf0wWTQYE1TsZCYQIrX7aWOuzw9NA1YZCrx2l0BmZChCKrZAy3WdZArBmMeIfImkobU7jMi3ubU3gp4kDHXM68r8iiPUdA7pIVQ5Ln2ZBWR0cuJ70yx9JZBaLnhEDmkVhWiO01gkB6oZBIqjYZD';
  
  const query = endPoint+'/'+id+'?'+options+'&'+accessToken;
  
  return new Promise((resolve,reject)=>{
    axios({
      method: 'GET',
      url: query
    })
      .then(response=>resolve(response))
      .catch(reject);
  });
  
};

